/*
| After a deploy, a tab opened on the previous build asks for chunks that no
| longer exist. Vite reports that as `vite:preloadError`; the cure is one
| reload onto the new build. The guard stops a genuinely missing chunk from
| reloading the page in a loop.
*/

const KEY = 'explorer-ui:stale-chunk-reload';
const GUARD_MS = 60_000;

export function shouldReloadForStaleChunk(storage, now = Date.now()) {
  if (!storage) return false;
  try {
    const last = Number(storage.getItem(KEY));
    if (Number.isFinite(last) && last > 0 && now - last <= GUARD_MS) return false;
    storage.setItem(KEY, String(now));
    return true;
  } catch {
    return false;
  }
}
